import e from "./index31.js";
import t from "./index32.js";
import { handleBreakpoints as n } from "./index33.js";
import { getPath as r } from "./index35.js";
import i from "./index36.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/spacing/spacing.js
var a = {
	m: "margin",
	p: "padding"
}, o = {
	t: "Top",
	r: "Right",
	b: "Bottom",
	l: "Left",
	x: ["Left", "Right"],
	y: ["Top", "Bottom"]
}, s = {
	marginX: "mx",
	marginY: "my",
	paddingX: "px",
	paddingY: "py"
}, c = i((e) => {
	if (e.length > 2) if (s[e]) e = s[e];
	else return [e];
	let [t, n] = e.split(""), r = a[t], i = o[n] || "";
	return Array.isArray(i) ? i.map((e) => r + e) : [r + i];
}), l = [
	"m",
	"mt",
	"mr",
	"mb",
	"ml",
	"mx",
	"my",
	"margin",
	"marginTop",
	"marginRight",
	"marginBottom",
	"marginLeft",
	"marginX",
	"marginY",
	"marginInline",
	"marginInlineStart",
	"marginInlineEnd",
	"marginBlock",
	"marginBlockStart",
	"marginBlockEnd"
], u = [
	"p",
	"pt",
	"pr",
	"pb",
	"pl",
	"px",
	"py",
	"padding",
	"paddingTop",
	"paddingRight",
	"paddingBottom",
	"paddingLeft",
	"paddingX",
	"paddingY",
	"paddingInline",
	"paddingInlineStart",
	"paddingInlineEnd",
	"paddingBlock",
	"paddingBlockStart",
	"paddingBlockEnd"
], d = [...l, ...u];
function f(e, t, n, i) {
	let a = r(e, t, !0) ?? n;
	return typeof a == "number" || typeof a == "string" ? (e) => typeof e == "string" ? e : (process.env.NODE_ENV !== "production" && typeof e != "number" && console.error(`MUI: Expected ${i} argument to be a number or a string, got ${e}.`), typeof a == "string" ? a.startsWith("var(") && e === 0 ? 0 : a.startsWith("var(") && e === 1 ? a : `calc(${e} * ${a})` : a * e) : Array.isArray(a) ? (e) => {
		if (typeof e == "string") return e;
		let n = Math.abs(e);
		process.env.NODE_ENV !== "production" && (Number.isInteger(n) ? n > a.length - 1 && console.error([
			`MUI: The value provided (${n}) overflows.`,
			`The supported values are: ${JSON.stringify(a)}.`,
			`${n} > ${a.length - 1}, you need to add the missing values.`
		].join("\n")) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join("\n")));
		let r = a[n];
		return e >= 0 ? r : typeof r == "number" ? -r : typeof r == "string" && r.startsWith("var(") ? `calc(-1 * ${r})` : `-${r}`;
	} : typeof a == "function" ? a : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${a}) is invalid.`, "It should be a number, an array or a function."].join("\n")), () => void 0);
}
function p(e) {
	return f(e, "spacing", 8, "spacing");
}
function m(e, t) {
	return typeof t == "string" || t == null ? t : e(t);
}
function h(e, t) {
	return (n) => e.reduce((e, r) => (e[r] = m(t, n), e), {});
}
function g(e, t, r, i) {
	if (!t.includes(r)) return null;
	let a = h(c(r), i), o = e[r];
	return n(e, o, a);
}
function _(e, n) {
	let r = p(e.theme);
	return Object.keys(e).map((t) => g(e, n, t, r)).reduce(t, {});
}
function v(e) {
	return _(e, l);
}
v.propTypes = process.env.NODE_ENV === "production" ? {} : l.reduce((t, n) => (t[n] = e, t), {}), v.filterProps = l;
function y(e) {
	return _(e, u);
}
y.propTypes = process.env.NODE_ENV === "production" ? {} : u.reduce((t, n) => (t[n] = e, t), {}), y.filterProps = u;
function b(e) {
	return _(e, d);
}
b.propTypes = process.env.NODE_ENV === "production" ? {} : d.reduce((t, n) => (t[n] = e, t), {}), b.filterProps = d;
//#endregion
export { p as createUnarySpacing, f as createUnaryUnit, m as getValue, v as margin, y as padding };

//# sourceMappingURL=index37.js.map